import { OperationType } from '@aavaz-ai/eql-parser-ts/dist/types';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { useFetchEQLReferences } from '@modules/queryBuilder/hooks';
import { ObjectType } from 'generated/graphql';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

export function useIsDurationCustomizationPossible() {
  const hasFeedbackField = useQuantifyStore(({ query }) => {
    if (query.groupBy?.objectType === ObjectType.Feedback) {
      return true;
    }

    if (query.measuredAsCriteria?.objectType === ObjectType.Feedback) {
      return true;
    }

    return false;
  });

  const combinedWhereClause = useQuantifyStore(({ query }) => {
    return query.whereClauseConfig?.whereClause || query.denominatorWhereClause
      ? combineWhereClauses(
          query.whereClauseConfig?.whereClause ?? EmptyWhereClause,
          query.denominatorWhereClause ?? EmptyWhereClause,
          OperationType.AND,
        )
      : EmptyWhereClause;
  });

  const { eqlFieldByID } = useFetchEQLReferences({
    whereClause: combinedWhereClause,
    skip: hasFeedbackField || combinedWhereClause === EmptyWhereClause,
  });

  const isFeedbackFieldPresentInFilters = Object.values(eqlFieldByID).some(
    (eqlField) => {
      return eqlField?.field?.objectType === ObjectType.Feedback;
    },
  );

  return hasFeedbackField || isFeedbackFieldPresentInFilters;
}
